'use strict';

module.exports = function enableTomSelectKeyboardReopen() {
    if (window.__tsKbdReopenAttached) {
        return;
    }
    window.__tsKbdReopenAttached = true;

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar'
            && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
            return;
        }
        var control = e.target && e.target.closest ? e.target.closest('.ts-control') : null;
        if (!control) {
            return;
        }
        var wrapper = control.closest('.ts-wrapper');
        var original = wrapper ? wrapper.previousElementSibling : null;
        var instance = original ? original.tomselect : null;
        if (instance && !instance.isOpen) {
            e.preventDefault();
            instance.open();
        }
    });
};
